/*
combined Form to allow save & share||download to be down in step
- Ensures we have metroRef for everything and a chance to get a jobNumber
- Avoids awkward AfterPrint action
 */
import React, {useEffect, useState} from "react";
import {Checkbox, Divider, Form, Input, Radio, Space} from "antd";
import {ObjectSelector} from "../AodUi/AodSelector";
import {includes, range, each, reduce} from "lodash";
import ModalForm from "../uiUtils/ModalForm";


const shareActions = ['PDF', 'Email', 'Print'];
const specAdSummary = "Ad summary";
const salesSheetSummary = "Presentation summary";

function getTitle(action, withSave, isShare, target){

    if (target==='salesSheet') {
        return(action==='PDF' ? 'View PDF of' : action) +
            ' ' +  salesSheetSummary;
    } else if (isShare) {
        return (withSave ? 'Save spec ad & ' : '') +
            (action==='PDF' ? 'View PDF of' : action) +
            ' ' + specAdSummary;
    } else if (action.startsWith('Save') ) {
        return 'Save spec ad';
    } else {
        return (withSave ? 'Save spec ad & ' : '') + action;
    }
}

const layout = {
    labelCol: { span: 4 },
    wrapperCol: { span: 20 },
}
const insetLayout = {
    labelCol: {offset: 4, span: 3},
};

export default function ActionModal(
    {
        advertiser, salesSheet,
        action, specAd,
        advSsList=[],
        target,   // salesSheet
        changes = false,
        formProps,
        ...props
    })
{
    const [showSalesSheetNew, setShowSalesSheetNew] = useState(false);
    const [submitAction, setSubmitAction] = useState();
    const [form] = Form.useForm();

    const isSave = action.startsWith('Save');
    const adCount = target==='salesSheet' ?salesSheet.specAds.length :0;
    const saveNeeded = target!=='salesSheet' && (!specAd || changes || isSave);
    const isShare = includes(shareActions,action);

    useEffect(()=>{
        if (advertiser) {
            setShowSalesSheetNew(advSsList.length === 0);
        }
    },[advSsList, advertiser]);

    useEffect(()=> setSubmitAction(action), [action]);

    /*
    useEffect(()=>{
        if (action ==='View Link' && !saveNeeded && !changes){
            form.submit();
        }
    },[action, saveNeeded, changes])
     */

    function onFieldsChange(changedFields, allFields){
        each(changedFields, field=> {
            if (field.name[0] === 'newSalesSheet') {
               setShowSalesSheetNew(field.value);
            }
            if (field.name[0] === 'saveAction') {
                if (isSave) {
                    setSubmitAction(field.value);
                }
                if (field.value === 'Save') {
                    //disable salesSheet choose/create
                    //reset to original sales sheet
                    console.log(formProps.initialValues);
                    form.setFieldsValue({
                        salesSheet:formProps.initialValues.salesSheet,
                        newSalesSheet: false
                    });
                }
            }
        });
    }

    return (
        <ModalForm width={600}
               title={getTitle(action, saveNeeded, isShare, target)}
               okText={submitAction}
               form={form}
               formProps={{...layout, onFieldsChange, ...formProps}}
               {...props}
        >
            {(action==='Print' || action ==='PDF') && <>
                <DetailsFields hideJobNumber={!saveNeeded}
                    adCount={adCount}
                />
                <Form.Item name='creator' label="Creator" noStyle>
                    <Input type="hidden" />
                </Form.Item>
            </>}

            {action ==='Email' && <>
                <EmailFields/>
                <DetailsFields headerLabel={'Subject'}
                               notesLabel={'Message'}
                               adCount={adCount}
                               hideJobNumber={!saveNeeded}
                />
            </>}

            {
                (action ==='Email Link' && <>
                    <EmailFields/>
                    <DetailsFields headerLabel={'Subject'}
                                   notesLabel={'Message'}
                                   hideJobNumber={!saveNeeded}
                    />
                </>)
                ||
                (!isShare && saveNeeded &&
                    <DetailsFields hideHeader={true}/>)
            }

            {action ==='View Link' && !saveNeeded &&
                <div>Click 'View Link' to gather production files</div>}

            <Form.Item noStyle hidden={!changes}>
                <Space align={'start'}>
                    <Form.Item name={'saveAction'} >
                        <Radio.Group>
                            <Space direction="vertical">
                                <Radio value={'Save'}>Update current spec ad</Radio>
                                <Radio value={'Save As'}>Create new spec ad</Radio>
                            </Space>
                        </Radio.Group>
                    </Form.Item>
                    <Form.Item
                        noStyle
                        shouldUpdate={fieldCompare('saveAction')}
                    >
                        {({ getFieldValue }) =>
                            getFieldValue('saveAction')==='Save' && specAd.locked ? (
                                <div style={{color:'salmon'}}>This spec ad has already been shared or downloaded!<br/>
                                    Create a new ad if you want to keep both versions.
                                </div>
                            ) : null
                        }
                    </Form.Item>
                </Space>
            </Form.Item>

            {saveNeeded && <>
                <SalesSheetFields
                    advSsList={advSsList}
                    showSalesSheetNew={showSalesSheetNew}
                />
            </>}
        </ModalForm>);
}


function SalesSheetFields(
    {
        advSsList,
       // showSalesSheetNew
    })
{
    const showSalesSheetSelect = advSsList.length > 0;

    //dependencies={['newSalesSheet']}

    return <>
        <Divider>Presentation</Divider>
        <Form.Item label={'Save to'}
                   hidden={!showSalesSheetSelect}
                   shouldUpdate={fieldCompare('newSalesSheet', 'saveAction')}
        >
            {({ getFieldValue }) =>
            <Space>
                <Form.Item noStyle name={'salesSheet'}
                           rules={[
                               ({ getFieldValue }) => ({
                                   validator(_, value) {
                                       if (value || getFieldValue('newSalesSheet') ) {
                                           return Promise.resolve();
                                       }
                                       return Promise.reject(new Error('Please select a presentation'));
                                   },
                               }),
                           ]}
                >

                    <ObjectSelector
                         list={advSsList}
                         disabled={getFieldValue('newSalesSheet') || getFieldValue('saveAction')==='Save' }
                         placeholder={'Select a presentation'}
                         sort
                    />
                </Form.Item>

                <Form.Item noStyle name={'newSalesSheet'}
                           valuePropName={'checked'}
                >
                    <Checkbox disabled={getFieldValue('saveAction')==='Save' }
                        >new presentation</Checkbox>
                </Form.Item>
            </Space>}
        </Form.Item>

        {showSalesSheetSelect || <div>New presentation</div>}

        <Form.Item
            noStyle
            shouldUpdate={fieldCompare('newSalesSheet')}
        >
            {({ getFieldValue }) =>
                getFieldValue('newSalesSheet') ? (
                    <>
                        <Form.Item name='name' label='Name' rules={[{required:true }]} {...insetLayout}>
                            <Input placeholder={'New presentation name'}/></Form.Item>
                        <Form.Item name='notes' label='Notes' {...insetLayout}>
                            <Input.TextArea/></Form.Item>
                    </>
                ) : null
            }
        </Form.Item>
    </>
}
/*
<AodSelector itemType={'salesSheet'}
             setName={salesSheetSetName}
             disabled={showSalesSheetNew}
             placeholder={'Select a presentation'}
             sort
/>
 */
/*
{showSalesSheetNew && <>
            <Form.Item name='name' label='Name' rules={[{required:true }]} {...insetLayout}>
                <Input placeholder={'New presentation name'}/></Form.Item>
            <Form.Item name='notes' label='Notes' {...insetLayout}>
                <Input.TextArea/></Form.Item>
        </>}
 */

/*
{({ getFieldValue }) =>
                        <ObjectSelector list={advSsList}
                                     disabled={getFieldValue('newSalesSheet')}
                                     placeholder={'Select a presentation'}
                                     sort
                        />}
 */



const fieldCompare = (...fields) =>
    (prevValues, currentValues) => reduce(
            fields,
            (changed, field)=> changed || prevValues[field] !== currentValues[field],
            false)


function DetailsFields(
    {
        hideJobNumber = false,
        hideHeader=false,
        headerLabel='Title',
        notesLabel='Notes',
        adCount=0,
        maxCols = 4
    })
{
    return <>
        {hideJobNumber || <Form.Item name='jobNumber' label='Job Number'>
            <Input placeholder={'customer reference'}/></Form.Item>}
        {hideHeader ||  <Form.Item name='subject' label={headerLabel} rules={[{required:true }]}>
            <Input.TextArea/></Form.Item>}
        <Form.Item name='text' label={notesLabel}>
            <Input.TextArea/></Form.Item>
        {(adCount > 1) && <Form.Item name='columns' label='Ads per row' >
            <Radio.Group>
                {range(1, Math.min(adCount, maxCols)+1).map(i=>
                    <Radio value={i} key={i}>{i}</Radio>)}
            </Radio.Group>
        </Form.Item>}
    </>
}

/*
{(adCount > 1) && <Form.item name='columns' label='Ads per row' >
            <InputNumber max={maxCols} min={0} />
        </Form.item>}


<Radio.Group>
                <Radio value={0} key={0}>auto</Radio>
                {range(1, Math.min(adCount, maxCols)+1).map(i=>
                    <Radio value={i} key={i}>{i}</Radio>)}
            </Radio.Group>
 */

function EmailFields(){
    return <>
        <Form.Item name='to' label='To' rules={[{ type: 'email'},{required:true }]}>
            <Input /></Form.Item>
        <Form.Item name='fromName' label='From' rules={[{required:true }]}>
            <Input placeholder={'name'}/></Form.Item>
        <Form.Item label='Reply to' required={true}>
            <Space>
                <Form.Item name='replyTo' noStyle rules={[{ type: 'email'},{required:true }]}>
                    <Input placeholder={'email address'} style={{width:300}}/></Form.Item>
                <Form.Item name='bccReplyTo' noStyle valuePropName="checked">
                    <Checkbox>BCC reply to</Checkbox></Form.Item>
            </Space>
        </Form.Item>
    </>
}